<template>
  <div class="text-center px-4">Customer is paying with cash.</div>
</template>
